import * as React from "react";
import { NavLink, Redirect } from "react-router-dom";
import { withTranslation } from "react-i18next";
import CoreComponent from "../CoreComponent";
import Axios, { AxiosResponse } from "axios";
import config from "../../config";
import { IObject, IHolder } from "../../interfaces";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { arrayToFormData, normalize } from "../../utils/functions";
import UserObjectModal from "../../components/UserObjectModal";

interface IState {
    objects: IObject[],
    year: number,
    month: number,
    limit: number,
    pagination: any,
    query: string,
    type: string,
    sort: string,
    isLoading: boolean,
    isOpen: boolean,
    currentPage: number,
    object: IObject
}

class Compositions extends CoreComponent<any, any> {
    state: IState = {
        objects: [],
        year: null,
        month: null,
        limit: 30,
        pagination: null,
        query: "",
        type: "",
        sort: "",
        isLoading: true,
        isOpen: false,
        currentPage: 1,
        object: null
    }

    constructor(props: any) {
        super(props);

        this.handleModal = this.handleModal.bind(this);
    }

    componentDidMount() {
        let _this = this;
    }

    async componentWillMount() {
        this.loadObjects();
    }

    async loadObjects() {
        this.setState({
            isLoading: true,
        }, async () => {
            let url = null;
            let limit = this.state.limit * this.state.currentPage;

            url = `${config.api}/composition?limit=${limit}`;

            if (this.state.year) {
                url += `&year=${this.state.year}`;
            }

            if (this.state.month) {
                url += `&month=${this.state.month}`;
            }

            if (this.state.sort) {
                url += `&sort=${this.state.sort}`;
            }

            if (this.state.type) {
                url += `&type=${this.state.type}`;
            }

            let res = await Axios.get(url);

            if (!this.isUnmounted) {
                this.setState({
                    objects: res.data.models,
                    pagination: res.data.pagination,
                    type: res.data.type,
                    sort: res.data.sort,
                    isLoading: false,
                    year: res.data.year,
                    month: res.data.month,
                })
            }
        })
    }

    setOrder(sort: string) {
        this.setState({
            type:
                this.state.sort != sort
                    ? (sort == "currency" ? "desc" : "asc")
                    : this.state.type == "asc"
                        ? "desc"
                        : "asc",
            sort,
        }, () => {
            this.loadObjects();
        });
    }

    showMore() {
        this.setState({
            currentPage: this.state.currentPage + 1
        }, () => {
            this.loadObjects();
        });
    }


    handleModal() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }

    changeYear(e: any) {
        this.setState({
            year: Number.parseInt(e.target.value)
        }, () => {
            this.loadObjects();
        })
    }

    years() {
        let years = [];

        for (let i = 2019; i <= new Date().getFullYear(); i++) {
            years.push(<option value={i} key={i}>{i}</option>);
        }

        return years;
    }

    changeMonth(e: any) {
        this.setState({
            month: Number.parseInt(e.target.value)
        }, () => {
            this.loadObjects();
        })
    }

    months() {
        let months = ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сенятрь", "Октябрь", "Ноябрь", "Декабрь"];
        let data = [];

        for (let i = 0; i < months.length; i++) {
            data.push(<option value={i + 1} key={i}> {months[i]} </option>);
        }

        return data;
    }

    render() {
        let { t, auth } = this.props;

        if (!auth.isAuthentificated) return <Redirect to="/login" />;

        return (
            <div>
                <UserObjectModal handleModal={this.handleModal} isOpen={this.state.isOpen} object={this.state.object} />
                <h1 className="riz-mobi__title">Объекты</h1>

                <div className="riz-mobi__balance">
                    <div className="wrapper">
                        <div className="riz-mobi__balance-cover">
                            <div className="riz-mobi__title-cover">
                                <span className="riz-mobi__balance-title"></span>
                                <select name="years" id="years" value={this.state.year} onChange={(e) => {
                                    this.changeYear(e);
                                }}>
                                    {this.years()}
                                </select>
                                <select name="month" id="month" value={this.state.month} onChange={(e) => {
                                    this.changeMonth(e);
                                }}>
                                    {this.months()}
                                </select>
                            </div>

                            <table className="riz-mobi__table riz-mobi__table-user riz-mobi__table-objects w-100">
                                <thead>
                                    <tr>
                                        <th>
                                            <a role="button" className="text-white" onClick={() => {
                                                this.setOrder("name");
                                            }}>
                                                Название
                                                <img src="img/Group 199.svg" alt="" className="ml-2" />
                                            </a>
                                        </th>
                                        {/* <th>
                                            <a role="button" className="text-white" onClick={() => {
                                                this.setOrder("co-author");
                                            }}>
                                                Со-автор
                                                <img src="img/Group 199.svg" alt="" className="ml-2" />
                                            </a>

                                        </th>
                                        <th>
                                            <a role="button" className="text-white" onClick={() => {
                                                this.setOrder("rate");
                                            }}>
                                                Ставка
                                                <img src="img/Group 199.svg" alt="" className="ml-2" />
                                            </a>
                                        </th> */}
                                        <th>
                                            <a role="button" className="text-white" onClick={() => {
                                                this.setOrder("views");
                                            }}>
                                                Кол-во просм.
                                                <img src="img/Group 199.svg" alt="" className="ml-2" />
                                            </a>
                                        </th>
                                        <th>
                                            <a role="button" className="text-white" onClick={() => {
                                                this.setOrder("currency");
                                            }}>
                                                Доход
                                                <img src="img/Group 199.svg" alt="" className="ml-2" />
                                            </a>
                                        </th>
                                        <th>Действия</th>
                                        <th><img src="img/crm-youtube.svg" alt="" /></th>
                                    </tr>
                                </thead>
                                <tbody>

                                    {!this.state.isLoading && this.state.objects.length == 0 && <tr><td colSpan={11} className="none-label-td">{t("Ничего не найдено")}</td></tr>}

                                    {this.state.isLoading && <tr><td colSpan={11} className="none-label-td">{t("Загрузка данных")}</td></tr>}

                                    {this.state.objects.map((object: IObject, i: number) => {

                                        return <tr key={i}>
                                            <td title={(object.name)}>
                                                {normalize(object.name)}

                                            </td>
                                            {/* <td>{object.coholders.map((holder: IHolder) => holder.full_name).join(", ")}</td>
                                            <td>{object.rate} %</td> */}
                                            <td>{object.views.toString().replace(/(\d)(?=(\d{3})+\b)/g, '$1,')}</td>
                                            <td className="price-success">${Number.parseFloat(
                                                object.doxod.toString()
                                            ).toFixed(3).slice(0, -1)}</td>
                                            <td>
                                                <a role="button" className="d-inline ml-2" onClick={() => {
                                                    this.setState({
                                                        object,
                                                        isOpen: true
                                                    })
                                                }}>
                                                    <img src="/img/Icon awesome-edit.svg" style={{ width: "14px" }} />
                                                </a>
                                            </td>
                                            <td>
                                                {object.place == "YouTube" && <a href={"https://youtu.be/" + object.youtube_id} target="_blink">
                                                    <img src="img/crm-youtube.svg" alt="" />
                                                </a>}
                                                {object.place != "YouTube" && object.youtube_id.startsWith("103") && <img src="img/ico1.svg" width="15" alt="" />}
                                                {object.place != "YouTube" && object.youtube_id.startsWith("A") && <img src="img/ico2.svg" width="15" alt="" />}
                                            </td>
                                        </tr>;
                                    })}

                                </tbody>
                            </table>
                            <div className="text-center p-3">
                                {this.state.objects.length > 0 && this.state.objects.length < (this.state.pagination?.totalCount) && <a role="button" className="spec-color fs-12" onClick={() => {
                                    this.showMore();
                                }}>Показать ещё...</a>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(function (state: any) {
    return {
        auth: state.auth
    };
})(withTranslation()(Compositions));
